import { useEffect } from 'react';
import { useOutletContext } from "react-router-dom";

import useTranslatePath from '../../../hooks/useTranslatePath';

import { t } from '../../../lib/translations';

import { Row } from '../../../components/grid';
import Addresses from '../../checkout/addresses/Addresses';
import BuilderSectionLazy from '../../builder/BuilderSectionLazy';

import Newsletter from './newsletter/Newsletter';
import EditProfile from './editprofile/EditProfile';

const Profile = () => {
    const { getPath } = useTranslatePath();
    const setBreadcrumb = useOutletContext();

    useEffect(() => {
        setBreadcrumb([
            { name: 'Home', url_key: '/' },
            { name: 'Account', url_key: '/account/overview' },
            { name: t('account.profile.header') }
        ]);
    }, []);

    return (
        <Row>
            <BuilderSectionLazy model="account-overview" url={getPath('/account/profile')} />
            <EditProfile />
            <Addresses isFromProfilePage={true}/> 
            <Newsletter />
        </Row>
    )
}

export default Profile;